import defaultRuntimeConfig from "./runtime-config-defaults.json";

interface C3RuntimeConfig {
  apiEndpoint?: string;
  isSsoEnabled?: string;
  oryJwtTemplateName?: string;
  orySdkUrl?: string;
  vectaraApiBaseUrl?: string;
  billingAgentKey?: string;
  billingOauthTokenEndpoint?: string;
}

declare global {
  interface Window {
    __C3_CONFIG__?: C3RuntimeConfig;
  }
}

const apiEndpoint = window.__C3_CONFIG__?.apiEndpoint ?? process.env.REACT_APP_API_ENDPOINT;
const orySdkUrl = window.__C3_CONFIG__?.orySdkUrl ?? process.env.REACT_APP_ORY_SDK_URL;

if (!apiEndpoint) {
  throw new Error("C3 API endpoint is not configured");
}
if (!orySdkUrl) {
  throw new Error("C3 Ory SDK URL is not configured");
}

export const config = {
  apiEndpoint,
  isSsoEnabled:
    window.__C3_CONFIG__?.isSsoEnabled ?? process.env.REACT_APP_IS_SSO_ENABLED ?? defaultRuntimeConfig.isSsoEnabled,
  oryJwtTemplateName:
    window.__C3_CONFIG__?.oryJwtTemplateName ??
    process.env.REACT_APP_ORY_JWT_TEMPLATE_NAME ??
    defaultRuntimeConfig.oryJwtTemplateName,
  orySdkUrl,
  vectaraApiBaseUrl:
    window.__C3_CONFIG__?.vectaraApiBaseUrl ??
    process.env.REACT_APP_VECTARA_API_BASE_URL ??
    defaultRuntimeConfig.vectaraApiBaseUrl,
  billingAgentKey:
    window.__C3_CONFIG__?.billingAgentKey ??
    process.env.REACT_APP_BILLING_AGENT_KEY ??
    defaultRuntimeConfig.billingAgentKey,
  billingOauthTokenEndpoint:
    window.__C3_CONFIG__?.billingOauthTokenEndpoint ??
    process.env.REACT_APP_BILLING_OAUTH_TOKEN_ENDPOINT ??
    defaultRuntimeConfig.billingOauthTokenEndpoint
};
